export default "https://cdn-static-staging.gokick.com/assets/283628f6afcc58bd5c20cb35203f3b9e086ea5d6/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";